
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function repeatI2(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function scopeProduct4() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn btn btn--secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '78241'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('div', { 'className': 'halo-item' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('div', {
                    'className': 'product-card',
                    'data-product-card': true,
                    'data-product-id': 'product-' + this.id,
                    'data-id': this.id
                }, _createElement('div', { 'className': 'product-image' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'product_badges' },
                    this.on_sale ? _createElement('div', {
                        'className': 'badge sale-badge',
                        'key': '274'
                    }, 'Sale') : null,
                    this.out_of_stock ? _createElement('div', {
                        'className': 'badge soldOut-badge',
                        'key': '344'
                    }, _translate(`product_out_of_stock`)) : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ]), _createElement('a', {
                    'className': 'product-link ' + (this.image2 ? 'image-swap' : ''),
                    'href': this.url,
                    'aria-label': 'link'
                }, _createElement('img', {
                    'className': 'lazyautosizes lazyloaded' + (this.image2 ? ' image-one' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'image-two lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image2)),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '990'
                }) : null), _createElement('a', {
                    'className': 'product-quickview',
                    'aria-label': 'quickview',
                    'id': this.handle,
                    'data-quickview': true,
                    'aria-describedby': 'a11y-external-message'
                }, '\n        ', _translate(`product_quick_view`), '\n      ')), _createElement('div', { 'className': 'product-content' }, _createElement('div', { 'className': 'product-detail' }, _createElement('div', { 'className': 'product-vendor' }, this.vendor && this.vendor_url ? _createElement('a', Object.assign({}, {
                    'href': this.vendor_url,
                    'title': this.removeHTML(this.vendor),
                    'key': '1547'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null), _createElement('h4', { 'className': 'product-title' }, _createElement('a', Object.assign({}, {
                    'href': this.url,
                    'aria-label': 'title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', {
                    'className': 'product-price' + (this.on_sale ? ' price--on-sale' : ''),
                    'data-price': true
                }, this.on_sale ? [
                    _createElement('span', {
                        'className': 'price-item price-item--regular',
                        'data-regular-price': true,
                        'key': '21521'
                    }, '\n              ', this.formatPrice(this.compare_at_price), '\n            '),
                    _createElement('span', {
                        'className': 'price-item price-item--sale',
                        'data-sale-price': true,
                        'key': '21523'
                    }, this.formatPrice(this.price))
                ] : null, !this.on_sale ? [
                    this.price_varies ? _createElement('span', { 'key': '24871' }, _translate(`price_from`), ' ') : null,
                    _createElement('span', {
                        'className': 'price-item price-item--regular',
                        'data-regular-price': true,
                        'key': '24873'
                    }, '\n              ', this.formatPrice(this.min_price || this.price), '\n            ')
                ] : null, this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2799'
                }, '\n            ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n          ') : null, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '30240'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI2.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '3432'
                }) : null, _createElement('a', {
                    'className': 'wishlist',
                    'aria-label': 'wishlist',
                    'data-icon-wishlist': true,
                    'href': '#',
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('svg', {
                    'viewBox': '0 0 1024 1024',
                    'className': 'icon icon-heart'
                }, _createElement('path', {
                    'className': 'path1',
                    'd': 'M486.4 972.8c-4.283 0-8.566-1.074-12.434-3.222-4.808-2.67-119.088-66.624-235.122-171.376-68.643-61.97-123.467-125.363-162.944-188.418-50.365-80.443-75.901-160.715-75.901-238.584 0-148.218 120.582-268.8 268.8-268.8 50.173 0 103.462 18.805 150.051 52.952 27.251 19.973 50.442 44.043 67.549 69.606 17.107-25.565 40.299-49.634 67.55-69.606 46.589-34.147 99.878-52.952 150.050-52.952 148.218 0 268.8 120.582 268.8 268.8 0 77.869-25.538 158.141-75.901 238.584-39.478 63.054-94.301 126.446-162.944 188.418-116.034 104.754-230.314 168.706-235.122 171.376-3.867 2.149-8.15 3.222-12.434 3.222zM268.8 153.6c-119.986 0-217.6 97.614-217.6 217.6 0 155.624 120.302 297.077 221.224 388.338 90.131 81.504 181.44 138.658 213.976 158.042 32.536-19.384 123.845-76.538 213.976-158.042 100.922-91.261 221.224-232.714 221.224-388.338 0-119.986-97.616-217.6-217.6-217.6-87.187 0-171.856 71.725-193.314 136.096-3.485 10.453-13.267 17.504-24.286 17.504s-20.802-7.051-24.286-17.504c-21.456-64.371-106.125-136.096-193.314-136.096z'
                })))), this.body_html && this.view === '1' ? _createElement('div', mergeProps({
                    'className': 'product-description',
                    'key': '4870'
                }, { dangerouslySetInnerHTML: { __html: typeof this.body_html === 'undefined' ? '' : this.body_html } })) : null, _createElement('div', { 'className': 'product-action' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'variants',
                    'id': 'list-product-form-' + this.id,
                    'data-id': 'product-actions-' + this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 || this.ProductScope === 'master' ? [_createElement('a', {
                        'className': 'btn product-btn',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '53161'
                    }, '\n                ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n              ')] : null, this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '56641'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '56643'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '56645'
                    }) : null,
                    _createElement('button', {
                        'data-btn-addtocart': true,
                        'className': 'btn product-btn',
                        'type': 'submit',
                        'data-form-id': '#list-product-form-' + this.id,
                        'disabled': this.out_of_stock,
                        'key': '56647'
                    }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                        _translate(`product_add_to_cart`),
                        this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                    ] : null)
                ] : null))), _createElement('div', { 'className': 'product-actions' }, _createElement('div', { 'className': 'product-action' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'variants',
                    'id': 'list-product-form-' + this.id,
                    'data-id': 'product-actions-' + this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'btn product-btn',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '69721'
                    }, '\n                ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n              ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '72761'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': '1',
                        'key': '72763'
                    }),
                    _createElement('button', {
                        'data-btn-addtocart': true,
                        'className': 'btn product-btn',
                        'type': 'submit',
                        'data-form-id': '#list-product-form-' + this.id,
                        'disabled': this.out_of_stock,
                        'key': '72765'
                    }, '\n                ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_add_to_cart`), '\n              ')
                ] : null), [scopeProduct4.apply(this, [])]), _createElement('button', {
                    'className': 'wishlist btn product-btn wishlist_mb',
                    'data-icon-wishlist': true,
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('span', { 'className': 'add' }, 'Add to Wish List'), _createElement('span', { 'className': 'remove' }, 'Remove Wish List'))))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products product-recommendations__items' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'halo-row halo-row-custom column-2 cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []